import React from 'react';
import Helmet from 'react-helmet';

export default function Template({
  data,
}) {
  const { markdownRemark } = data;
  const { frontmatter, html } = markdownRemark;
  return (
      <div>
          <Helmet>
              {/* General tags */}
              <title>{frontmatter.title}</title>
              <meta name="title" content={frontmatter.title} />

              <meta name="description" content={frontmatter.description} />
              <meta name="image" content={frontmatter.image} />

              {/* OpenGraph tags */}
              <meta property="og:title" content={frontmatter.title} />
              <meta property="og:description" content={frontmatter.description} />
              <meta property="og:image" content={frontmatter.image} />

              {/* Twitter Card tags */}
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:title" content={frontmatter.title} />
              <meta name="twitter:description" content={frontmatter.description} />
              <meta name="twitter:image" content={frontmatter.image} />
          </Helmet>
          <script
              dangerouslySetInnerHTML={{
                  __html: `
            if (typeof window !== 'undefined') { window.location = "${frontmatter.cannonical}"; }
        `,
              }}
          />
      </div>
  );
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        image
        description
        cannonical
        fb_app_id
        twitter_creator_id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/blogTemplate.js